/**
 * Karte „Lohn & Abrechnung" — reine Anzeige (Entscheidung #19d, Kapitel 7.1/20.4).
 *
 * Bis einschließlich Task 7 konnte hier jeder seinen eigenen Stundenlohn und
 * das Lohn-Modell selbst ändern (`PUT /api/me/wage`/`/salary`) — das war eine
 * v1-Lücke (widersprach bereits Kapitel 20.3) und ist jetzt geschlossen: beide
 * Endpunkte lehnen eine Selbstbearbeitung serverseitig ab. Ändern kann den
 * Lohn jetzt ausschließlich eine ANDERE Person mit den passenden Rechten
 * (Chef überall, Filialleitung an eigenen Standorten) über die
 * Mitarbeiter-Verwaltung.
 */

import { useAuth } from '../store/auth';
import { formatMoney } from '../lib/format';

export function SalarySettingsCard() {
  const user = useAuth((s) => s.user);

  if (!user) return null;

  return (
    <div className="card p-4">
      <div className="min-w-0">
        <p className="text-sm font-medium">Lohn &amp; Abrechnung</p>
        <p className="text-xs text-slate-400 mt-0.5">
          Stundenlohn{' '}
          <span className="text-emerald-400 font-medium">{formatMoney(user.hourlyWage)}</span>
          {user.salaryMode === 'salary'
            ? ` · Festgehalt ${formatMoney(user.monthlySalary)} für ${user.monthlyTargetHours
                .toFixed(2)
                .replace('.', ',')} Std.`
            : ' · Reiner Stundenlohn'}
        </p>
        <p className="text-[11px] text-slate-500 mt-1.5">
          Nur zur Anzeige — ändern kann das nur dein Chef oder deine Filialleitung.
        </p>
      </div>
    </div>
  );
}
